import { Pipe, PipeTransform } from '@angular/core';
import { RespostasCriticasSolucoesDetalhesCabecalhosConferenciasDeFaturasDTO as Critica } from '../../models/conferencia-de-fatura/DetalheBeneficiarioConferenciaDeFatura';

@Pipe({
  name: 'codigoCriticas',
})
export class CodigoCriticaDetalheConferenciaFaturaPipe
  implements PipeTransform
{
  transform(criticas: Critica[]): string {
    return criticas
      .map(
        (critica) => ` ${critica.respostaCriticaConferenciaDeFaturaDTO.codigo || ''}`
      ).filter(code => code.trim() !== '')
      .toString();
  }
}
